import { FC } from "react";

import CustomComponentRightButtonTerritories from "../customComponentRightButtonTerritories";

import { StatisticsObjectType } from "../caseVolumeLineChart/types";
import CustomLineChart from "../customLineChart";



const CustomComponentCaseVolumeTerritories: FC<StatisticsObjectType> = ({ StatisticsObjectType, buttonShows }): JSX.Element => {
  return (
    <div className="row mt-3 gx-2">
      <div className={` ${buttonShows ? " col-12 col-lg-8 mb-3" : "col"}`} style={{ maxHeight: 550}}>
        <CustomLineChart title="Case Volume" LineChartObject={StatisticsObjectType.case_volume} />
      </div>

      {buttonShows &&
        <div className="col-12 col-lg-4 d-flex flex-column flex-fill" style={{maxHeight:550}}>
          <CustomComponentRightButtonTerritories StatisticsObjectType={StatisticsObjectType} />
        </div>
      }
    </div>
  )
}

export default CustomComponentCaseVolumeTerritories;
